import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AvailableParking, ParkingVM, ParkingSiteRowVM } from '../models/parkingsite.model';
import { EditOrderParking, OrderParkingVM } from '../models/orderModel';

@Injectable({
  providedIn: 'root'
})
export class ParkingService {
  hostPath: string = JSON.parse(environment.IDENTITY);
  adminPath = 'Shuttlebuss/Shuttlebuss.Service/admin';

  constructor(private http: HttpClient) { }

  public setNewParkingSite(orderParkingId: string, parkingSiteId: string, isadmin: boolean): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/setnewparkingsite/${orderParkingId}/${parkingSiteId}/${isadmin}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParkingVM => {
        return orderParkingVM;
      }),
      catchError(this.handleError)
    );
  }

  public setAnyNewParkingSite(orderParkingId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/setanynewparkingsite/${orderParkingId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParking => {
        return orderParking;
      }),
      catchError(this.handleError)
    );
  }

  public editOrderParking(editOrderParking: EditOrderParking): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/orderparking/editorderparking';
    return this.http
      .post<EditOrderParking>(url, editOrderParking, { headers })
      .pipe(map(orderParkingVM => {
        return orderParkingVM;
      }),
        catchError(this.handleError)
      );
  }

  public setStatusCheckInParkingSiteId(orderParkingId: string, checkIn: string, parkingSiteId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/setstatuscheckin/${orderParkingId}/${checkIn}/${parkingSiteId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParkingVM => {
        return orderParkingVM;
      }),
      catchError(this.handleError)
    );
  }

  public setStatusCheckIn(orderParkingId: string, checkIn: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/setstatuscheckin/${orderParkingId}/${checkIn}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParkingVM => {
        return orderParkingVM;
      }),
      catchError(this.handleError)
    );
  }

  public setStatusCheckOut(orderParkingId: string, checkOut: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/setstatuscheckout/${orderParkingId}/${checkOut}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParkingVM => {
        return orderParkingVM;
      }),
      catchError(this.handleError)
    );
  }

  public setStatusNoShow(orderParkingId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/setstatusnoshow/${orderParkingId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParkingVM => {
        return orderParkingVM;
      }),
      catchError(this.handleError)
    );
  }

  public setStatusPaid(orderParkingId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/setstatuspaid/${orderParkingId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParkingVM => {
        return orderParkingVM;
      }),
      catchError(this.handleError)
    );
  }

  public setStatusReserved(orderParkingId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/setstatusreserved/${orderParkingId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParkingVM => {
        return orderParkingVM;
      }),
      catchError(this.handleError)
    );
  }

  public resetCheckIn(orderParkingId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/resetCheckin/${orderParkingId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParkingVM => {
        return orderParkingVM;
      }),
      catchError(this.handleError)
    );
  }

  public resetCheckOut(orderParkingId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/resetcheckout/${orderParkingId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderParkingVM => {
        return orderParkingVM;
      }),
      catchError(this.handleError)
    );
  }

  public getAvailableParkingSites(parkingId: string, productId: string, from: any, to: any): Observable<AvailableParking[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/parking/availableparkingsites/${parkingId}/${productId}/${from}/${to}`;
    return this.http.get<AvailableParking[]>(URL).pipe(
      map(parkingSite => {
        return parkingSite;
      }),
      catchError(this.handleError)
    );
  }

  public getAllAvailableParkingSites(parkingId: string, productId: string, from: any, to: any): Observable<AvailableParking[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/parking/allavailableparkingsites/${parkingId}/${productId}/${from}/${to}`;
    return this.http.get<AvailableParking[]>(URL).pipe(
      map(parkingSite => {
        return parkingSite;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(`checkoutService.handleError ${errMsg}`);
    return throwError(error);
  }
}
